<template>
  <div class="card">
    <h3>{{ total_result_count }} {{ total_result_count === 1 ? 'Response' : 'Responses'}}</h3>
    <a-divider />
    <template v-for="(result, result_index) in results">
      <div class="result">
        <div class="text-container">
          <div>
            <p class="result_title">{{ result.option }}</p>
          </div>
          <div class="result-stats">
            <p class="result_count">{{ result.count }}</p>
            <a-tooltip v-if="!_.isEmpty(getRespondentsWhoSelectedOption(result_index))">
              <template slot="title">
                Respondents</br>
                <template v-for="respondent of getRespondentsWhoSelectedOption(result_index)">
                  {{ respondent }}</br>
                </template>
              </template>
              <img class="result_count_icon" src="../../assets/icons/user-icon.svg">
            </a-tooltip>
            <img v-else class="result_count_icon" src="../../assets/icons/user-icon.svg">
            <!-- <img class="result_count_icon" src="../../assets/icons/user-icon.svg"> -->
            <p class="result_percentage">{{ Math.round(result.count / total_result_denominator * 100) }}%</p>
          </div>
        </div>
        <div class="bar-container">
          <div class="bar" v-bind:style="{ width: (result.count / total_result_denominator * 100) + '%' }"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'multiChoiceAnswer',
  props: {
    answers: Array,
    multi_choice_options: Array
  },
  computed: {

    total_result_count() {
      return _.sumBy(this.results, 'count') || 0;
    },

    total_result_denominator() {
      return _.sumBy(this.results, 'count') || 1;
    },

    results() {

      let _results = _.map(this.multi_choice_options, (val, index) => ({
        option: val.text,
        count: 0
      }));

      let votes = _.map(this.answers, answer => {
        return answer.answer || 0; // TEMP
      });

      for (let option_index of votes) {
        if (_results[option_index]) {
          _results[option_index].count = _results[option_index].count + 1;
        };
      };

      return _results;

    },

  },

  methods: {

    getRespondentsWhoSelectedOption(option_index) {

      let uids = _
      .chain(this.answers)
      .filter(answer => parseInt(answer.answer) === option_index)
      .map('uid')
      .compact()
      .value();

      if (uids.length > 15) {
        let excess_uid_count = uids.length - 15;
        uids = uids.slice(0, 15);
        uids.push(`and ${excess_uid_count} more`);
      };

      return uids;

    }

  }

}
</script>

<style scoped lang="scss">

.card{
  width: 450px;
  padding: 30px;
  padding-bottom: 45px;
  margin: 0 auto;
  margin-top: 70px;
  background-color: white;
  border: 1px solid #ECECEC;
  border-radius: 6px;
  box-shadow: 0 0 8px 0 rgba(0,0,0,.08);
}

h3{
  text-align: center;
  font-weight: 600;
}

.result{
  margin-top: 25px;
}

// Bar Colors
div.result{
  &:nth-of-type(1) .bar{
    background-color: #FEC317;
  }
  &:nth-of-type(2) .bar{
    background-color: #38D8A9;
  }
  &:nth-of-type(3) .bar{
    background-color: #2F44EA;
  }
  &:nth-of-type(4) .bar{
    background-color: #FE8787;
  }
  &:nth-of-type(5) .bar{
    background-color: #FEC317;
  }
  &:nth-of-type(6) .bar{
    background-color: #38D8A9;
  }
  &:nth-of-type(7) .bar{
    background-color: #2F44EA;
  }
}

.text-container{
  display: flex;
  justify-content: space-between;
  div > * {
    display: inline-block;
    margin-bottom: 11px;
    &.result_title{
      font-size: 17px;
      font-weight: 600;
    }
    &.result_count{
      font-weight: 500;
    }
    &.result_percentage{
      font-weight: 600;
    }
    &.result_count, &.result_percentage{
      font-size: 14px;
    }
    &.result_count_icon{
      height: 15px;
      margin-bottom: 2px;
      margin-left: 3px;
    }
  }
  .result-stats{
    white-space: nowrap;
  }
  div:last-child p{
    margin-left: 12px;
  }
}


.bar-container{
  background-color: rgb(234,236,235);
  height: 20px;
  width: 100%;
  position: relative;
  border-radius: 4px;
  .bar{
    background-color: blue;
    position: absolute;
    height: 20px;
    width: 0px;
    border-radius: 4px;
    transition: width .5s;
  }
}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {
.card{
  width: 100%;
  margin-top: 0px;
}
}


</style>
